<template>
  <div>
    <v-dialog v-model="cellsDialog" max-width="700">
      <AvailableBalancedCells
        :deleteButton="false"
        :editButton="false"
        :selectButton="true"
        :refresh="false"
        :selectCell="cellSelected"
      />
    </v-dialog>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Value</th>
            <th>Power</th>
            <th>Power / Value</th>
            <th>#</th>
            <th>Value</th>
            <th>Power</th>
            <th>Power / Value</th>
            <th>Total Power / Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(battery, i) in batteryDetail.cells" :key="i">
            <td>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    v-on="on"
                    color="primary"
                    @click="editBattery(battery.cells[0].number, i, 0)"
                    >{{ battery.cells[0].number }}</v-btn
                  >
                </template>
                <span>Click to edit {{ battery.cells[0].number }}</span>
              </v-tooltip>
            </td>
            <td>{{ battery.cells[0].value }}</td>
            <td>{{ battery.cells[0].power }}</td>
            <td>{{ battery.cells[0].pov }}</td>
            <td>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    v-on="on"
                    color="primary"
                    @click="editBattery(battery.cells[1].number, i, 1)"
                    >{{ battery.cells[1].number }}</v-btn
                  >
                </template>
                <span>Click to edit {{ battery.cells[1].number }}</span>
              </v-tooltip>
            </td>
            <td>{{ battery.cells[1].value }}</td>
            <td>{{ battery.cells[1].power }}</td>
            <td>{{ battery.cells[1].pov }}</td>
            <td>{{ battery.pov }}</td>
          </tr>
          <tr>
            <td colspan="9"></td>
          </tr>
          <tr>
            <td colspan="9"></td>
          </tr>
          <tr>
            <th colspan="2"></th>
            <th colspan="2">Max</th>
            <th colspan="2">Min</th>
            <th colspan="2">Difference</th>
            <th></th>
          </tr>
          <tr
            v-for="(battery, i) in batteryMeta.batteryStrength"
            :key="`meta-${i}`"
          >
            <td colspan="2">{{ battery.name }}</td>
            <td colspan="2">{{ battery.max }}</td>
            <td colspan="2">{{ battery.min }}</td>
            <td colspan="2">{{ (battery.max - battery.min) | number }}</td>
            <td></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import api from "@/api";
import AvailableBalancedCells from "../cells/AvailableBalancedCells";
export default {
  name: "EditBattery",
  components: {
    AvailableBalancedCells,
  },
  data: () => ({
    cellsDialog: false,
    dialog: false,
    loading: false,
    batteryDetail: {
      cells: [],
    },
    batteryMeta: {
      batteryStrength: [],
    },
    editItem: {},
  }),
  filters: {
    number: function (value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
  },
  methods: {
    initialize() {
      this.getItem();
    },
    async getItem() {
      try {
        const response = await api.getBattery(this.$route.params.batteryId);
        const battery = response.data[0];
        battery.cells = JSON.parse(battery.cells);
        this.batteryDetail = battery;
        const cells = [];
        battery.cells.forEach((b) => {
          b.cells.forEach((c) => cells.push(c));
        });
        this.batteryMeta = this.$getBatteryMeta(cells);
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },
    async editBattery(cellNumber, cellIndex, cellPairIndex) {
      this.editItem = { cellNumber, cellIndex, cellPairIndex };
      this.cellsDialog = true;
    },
    async cellSelected(newCell) {
      const { cellIndex, cellPairIndex } = this.editItem;

      const oldCellNumber =
        this.batteryDetail.cells[cellPairIndex].cells[cellIndex].number;
      const cells = this.$clone(this.batteryDetail.cells);
      cells[cellPairIndex].cells[cellIndex] = newCell;
      const { batteryId } = this.$route.params;
      var payload = {
        cells: cells,
        batteryId,
        newCellId: newCell.id,
        newCellNumber: newCell.number,
        oldCellNumber,
      };
      try {
        await api.updateBattery(batteryId, payload);
        this.cellsDialog = false;
        this.getItem();
        this.editItem = {};
        this.$toast.success("Cell Changed");
      } catch (error) {
        this.$toast.error("Error");
      }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>